module.exports = __webpack_public_path__ + "static/media/lock-small.7d19c790.svg";